const env = process.env.NODE_ENV
const name = process.env.VUE_APP_NAME
function getDifAddress (name) {
  let apiUrl = null
  switch (name) {
    case 'defalut':
      apiUrl = env === 'production' ? 'https://singapore.fooyotravel.com/' : 'https://singapore-staging.fooyotravel.com/'
      break
    case 'wholesale':
      apiUrl = env === 'production' ? 'https://fulai-api.neutronapi.run/' : 'https://fulai-api.neutronapi.run/'
      break
    case 'fooyo':
      apiUrl = env === 'production' ? 'https://singapore.fooyotravel.com/' : 'http://localhost:3000'
      break
    case 'zoo':
      apiUrl = env === 'production' ? 'https://singapore-zoo.fooyotravel.com/' : 'https://minishop-staging.neutron.sg/'
      break
    case 'wholesale_fulai':
      apiUrl = env === 'production' ? 'https://fulai-api.neutronapi.run/' : 'https://fulai-api.neutronapi.run/'
      break
    case 'minishop':
      apiUrl = env === 'production' ? 'https://neucommerce.neutronapi.run/' : 'https://neucommerce.neutronapi.run/'
      break
    default:
      apiUrl = 'http://192.168.124.13:4000'
      break
  }
  return apiUrl
}
const apiUrl = getDifAddress(name)
export default apiUrl
